import React, { useMemo } from 'react'
import { MenuItem, FormControl, TextField, Typography, Paper } from '@mui/material'
import styles from './Select.module.scss'

export default function SelectWithExternalLabel({options, value, setValue, disable, label, helper, elevation, fieldName, style = {}}) {
  const selectedDataset = (e) => setValue(e.target)

  const validOptions = useMemo(()=>{
    return options?.map((item, i)=> <MenuItem disabled={item.disable} key={i} value={item.value}>{item.name}</MenuItem>)
  },[options])

  return (
    
     <FormControl fullWidth size="small">
        <Typography variant='body2'>{label}</Typography>
        <Paper elevation={elevation} >
        <TextField
            fullWidth
            disabled={disable}
            select
            size="small"
            InputProps={{style, classes: {root : styles['select-input']}}}
            onChange={selectedDataset}
            value={value}
            name={fieldName}
            helperText={helper}
        >
        {validOptions}
        </TextField>
        </Paper>
      </FormControl>
    
  )
}

SelectWithExternalLabel.defaultProps = {
  elevation: 5,
}